/* eslint-disable no-undef */
// import axios from 'axios';
import ErrorHandler from 'Components/ErrorHandler';
import axiosAPI from './api';
import axiosNotificationApi from './notificationApi';
import Swal from 'sweetalert2';
import ReactGA from 'react-ga';

import GATrackingIds from "Constants/GoogleAnalyticsMapping";
import { viewTime } from 'Includes/viewFunctions';
import { GET_URL, POST_URL, PUT_URL, PATCH_URL, DEL_URL } from 'Includes/urls'

function getRequest(url, params, props) {
  let data = {};
  if (params) {
    data = { ...params };
  }
  const label = url + 'data:' + JSON.stringify(data);
  axiosAPI.defaults['responseType'] = XMLHttpRequest.responseType
  if (props && props.responseType) {
    axiosAPI.defaults['responseType'] = props.responseType;
  }
  return axiosAPI.get(url, { params: { ...data } }).then((response) => {
    if (response.status === 200) {
      setGAAPIEvent(props, 'GET', 'Success', label);
      return response;
    }
  }).catch(function (error) {
    setGAAPIEvent(props, 'GET', 'Failure', label);
    if (props && props.return_error) {
      return error.response;
    }
    else {
      return ErrorHandler(error, props);
    }
  });
}

function postRequest(url, data, props) {
  let params = {};
  if (data) {
    params = data;
  }
  const label = url + 'data:' + JSON.stringify(params);
  // Explicitly set Content-Type to application/json if not provided
  const contentType = (props && props.contentType) ? props.contentType : 'application/json';
  const headers = {
    'Content-Type': contentType
  };
  
  // Always read the token fresh from localStorage so auth is never missing
  const token = localStorage.getItem('token');
  if (token) {
    headers['Authorization'] = 'Token ' + token;
  }
  
  return axiosAPI.post(url, params, { 
    headers: headers,
    withCredentials: false 
  }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      setGAAPIEvent(props, 'POST', 'Success', label);
      return response;
    }
  }).catch(function (error) {
    setGAAPIEvent(props, 'POST', 'Failure', label);
    if (props && props.return_error) {
      return error.response;
    }
    else {
      return ErrorHandler(error, props);
    }
  });
}

function putRequest(url, data, props) {
  let params = {};
  if (data) {
    params = data;
  }
  const label = url + 'data:' + JSON.stringify(params);
  
  // Build headers
  const headers = {};
  
  // For FormData, don't set Content-Type - let browser set it with boundary
  // For other data types, set Content-Type
  if (params instanceof FormData) {
    // Don't set Content-Type for FormData - browser will set it with boundary
  } else {
    // Set default Content-Type to application/json if not specified
    const contentType = (props && props.contentType) ? props.contentType : 'application/json';
    headers['Content-Type'] = contentType;
  }
  
  // Always read the token fresh from localStorage so auth is never missing
  const token = localStorage.getItem('token');
  if (token) {
    headers['Authorization'] = 'Token ' + token;
  }
  
  return axiosAPI.put(url, params, { 
    headers: Object.keys(headers).length > 0 ? headers : undefined,
    withCredentials: false 
  }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      setGAAPIEvent(props, 'PUT', 'Success', label);
      return response;
    }
  }).catch(function (error) {
    setGAAPIEvent(props, 'PUT', 'Failure', label);
    if (props && props.return_error) {
      return error.response;
    }
    else {
      return ErrorHandler(error, props);
    }
  });
}

function patchRequest(url, data, props) {
  let params = {};
  if (data) {
    params = data;
  }
  const label = url + 'data:' + JSON.stringify(params);
  if (props && props.contentType) {
    axiosAPI.defaults.headers['Content-Type'] = props.contentType;
  }
  // axiosAPI.defaults.headers.post['Content-Type'] = props.contentType;
  return axiosAPI.patch(url, params, { withCredentials: false }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      setGAAPIEvent(props, 'Patch', 'Success', label);
      return response;
    }
  }).catch(function (error) {
    setGAAPIEvent(props, 'Patch', 'Failure', label);
    ErrorHandler(error);
  });
}

function deleteRequest(url, data, props) {
  return Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: props['confirmButtonText'] ? props['confirmButtonText'] : 'Yes, delete it!'
  }).then(async (result) => {
    if (result.value) {
      let params = {};
      if (data) {
        params = data;
      }
      const label = url + 'data:' + JSON.stringify(params);
      return axiosAPI.delete(url, params, { withCredentials: false }).then((response) => {
        if (response.status === 200) {
          setGAAPIEvent(props, 'Delete', 'Success', label);
          return response;
        }
      }).catch(function (error) {
        setGAAPIEvent(props, 'Delete', 'Failure', label);
        ErrorHandler(error);
      });
    }
  });
}

function postRequestOnConfirm(url, data, props, type) {
  let confirmMessage
  if (type) {
    confirmMessage = type === "Approve" ? "Yes, Approve it!" : "Yes, Pay Salary!"
  }
  return Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: props['confirmButtonText'] ? props['confirmButtonText'] : `${confirmMessage}`
  }).then(async (result) => {
    if (result.value) {
      let params = {};
      if (data) {
        params = data;
      }
      if (props && props.contentType) {
        axiosAPI.defaults.headers['Content-Type'] = props.contentType;
      }
      return axiosAPI.post(url, params, { withCredentials: false }).then((response) => {
        if (response.status === 200) {
          if (response.data === "2FA required") {
            viewTime()
          }
          else {
            return response;
          }
        }
      }).catch(function (error) {
        if (props && props.return_error) {
          return error.response;
        }
        else {
          return ErrorHandler(error, props);
        }
      });
    }
  });
}

function postNotificationRequest(url, data, props) {
  let params = {};
  if (data) {
    params = data;
  }
  if (props && props.contentType) {
    axiosNotificationApi.defaults.headers['Content-Type'] = props.contentType;
  }
  return axiosNotificationApi.post(url, params, { withCredentials: false }).then((response) => {
    if (response.status === 200) {
      return response;
    }
  }).catch(function (error) {
    if (props && props.return_error) {
      return error.response;
    }
    else {
      return ErrorHandler(error, props);
    }
  });
}

export const setGAAPIEvent = (props, category, status, label) => {
  const { host } = window.location;
  const mapping = getURLData(category);
  const trackingId = Object.prototype.hasOwnProperty.call(GATrackingIds, host) && GATrackingIds[host];
  const gaEventName = props && props.apiKey && mapping && mapping[props.apiKey] && mapping[props.apiKey].eventName;
  if (trackingId && gaEventName) {
    ReactGA.event({ category: `API - ${category} - ${status}`, action: gaEventName, label });
  }
}

const getURLData = (category) => {
  switch(category){
    case 'GET': return GET_URL;
    case 'POST': return POST_URL;
    case 'PUT': return PUT_URL;
    case 'PATCH': return PATCH_URL;
    case 'DEL': return DEL_URL;
    default: return null;
  }
}

export { getRequest, postRequest, putRequest, deleteRequest, patchRequest, postRequestOnConfirm, postNotificationRequest };